import { render, staticRenderFns } from "./dealer-agreement-form-field-checkbox.vue?vue&type=template&id=f9cf782a"
import script from "./dealer-agreement-form-field-checkbox.vue?vue&type=script&lang=js"
export * from "./dealer-agreement-form-field-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports